import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6e4bdc38")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: {'rounded-3xl flex': _ctx.centerButton, buttonAlignment: _ctx.buttonAlignment}
  }, [
    _createVNode("a", {
      class: ['rounded-full cursor-pointer dark:text-gray-400 link-button font-medium ' + _ctx.buttonWidth, _ctx.buttonXPadding, _ctx.buttonYPadding, _ctx.buttonHover, _ctx.buttonColor, _ctx.textColor, _ctx.buttonWidth, _ctx.customCss, _ctx.textAlignment],
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.redirectToLink && _ctx.redirectToLink(...args)))
    }, _toDisplayString(_ctx.buttonText), 3)
  ], 2))
})